const devLog = (...args) => {
  console.log('[VrClient]', ...args)
}
//  console.log(localStorage.local_ip)
let userAgent = navigator.userAgent;
let sendAnswer = false
let issafari = false
let sendMsgInt
let mesgsReceive = []
// && userAgent.indexOf("Chrome") == -1
if (userAgent.indexOf("Safari") > -1) {
  issafari = true
}
// alert(userAgent+'')
window.RTCPeerConnection = window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.RTCPeerConnection
window.RTCSessionDescription = window.mozRTCSessionDescription || window.RTCSessionDescription
window.RTCIceCandidate = window.mozRTCIceCandidate || window.RTCIceCandidate

navigator.getUserMedia = navigator.mozGetUserMedia || navigator.webkitGetUserMedia
window.URL = window.webkitURL || window.URL

const mediaConstraints = {
  optional: [],
  mandatory: {
    OfferToReceiveAudio: true,
    OfferToReceiveVideo: true
  }
}

const instanceList = []

window.addEventListener('unload', () => {
  instanceList.forEach(it => it.close())
})


class VrClient {
  address = ''

  client = null

  topic = null

  to = ''

  video = null

  constructor(address) {
    this.address = address
    instanceList.push(this)
  }

  connect() {
    return new Promise((resolve, reject) => {
      console.log(`正在连接服务器 ${this.address}`)
      const schoolInfo = JSON.parse(window.localStorage.getItem('school'))
      const schoolKey = schoolInfo.school_key
      const user = JSON.parse(this.getCookie('user'))
      // let randomTime = window.localStorage.getItem('randomTime')
      // if(!randomTime){
      //   let time = Date.now()
      //   randomTime = time
      //   window.localStorage.setItem('randomTime', randomTime)
      // }
      // let timetest = Date.now()
      // let clientId = schoolKey + '_' + user.id + '_' + randomTime
      // console.log('clientId', clientId)
      const settings = {
        clientId: schoolKey + '_' + user.id + '_' + Date.now(),
        username: 'emqx-connect-via-websocket22',
        password: 'emqx-connect-via-websocket22',
        connectTimeout: 4000,
      }
      const client = this.client = mqtt.connect(this.address, settings)

      client.on('connect', () => {
        console.log('成功连接服务器')
        resolve()
      })

      client.on('reconnect', error => {
        console.log('正在重连：', error)
      })

      client.on('error', error => {
        console.log('连接失败：', error)
        reject(error)
      })

      client.on('message', (topic, message) => {
        const msg = message.toString()
        let msgFormat = JSON.parse(msg)
        console.log('msg', topic)
        console.log('msg', msg)
        this.receiveMessage(msgFormat)
      })
    })
  }
  getCookie(name) {
    var arr;
    var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;

    }
  };

  play({ webTopic, topic, to, video } = {}) {
    try {
      this.topic = topic
      this.to = to
      this.video = video
      this.client.subscribe(webTopic, { qos: 2, retain: false }, error => {
        console.log('成功连接服务器')
        if (!error) {
          this.send({ info: { type: 'init' } })
        }
      })
    } catch (ex) {
      console.log('error', ex)
    }
  }

  bye() {
    if (this.client) {
      console.log('---> bye')
      this.send({ info: { type: 'bye' } })
    }
    if (this.answerer) {
      this.answerer.close()
    }
    if (this.video) {
      this.video.srcObject = null
    }
    clearInterval(sendMsgInt)
    sendAnswer = false
  }

  close() {
    this.bye()
    console.log('---> stop')
    this.send({ info: { type: 'stop' } })
    setTimeout(() => {
      this.client.end(true, '', error => {
        devLog('---> end')
        error && devLog('error', error)
      })
    }, 3000)
    if (this.video) {
      this.video.srcObject = null
    }
  }

  send(data) {
    const intent = {
      msg_id: 0,
      time: Date.now(),
      action: 'live',
      ...data,
      info: {
        from: 'web',
        to: this.to,
        ...data.info
      }
    }
    console.log('send', intent)
    this.client.publish(this.topic, JSON.stringify(intent), { qos: 2, retain: true })
    let that = this
    if (data.info && data.info.type === 'start') {
      clearInterval(sendMsgInt)
      sendMsgInt = window.setInterval(function () {
        const newIntent = {
          msg_id: 0,
          time: Date.now(),
          action: 'alive',
          ...data,
          info: {
            from: 'web',
            to: '',
            type: 'alive'
          }
        }
        if (!that.isMinStatus()) {
          that.client.publish(that.topic, JSON.stringify(newIntent), { qos: 2, retain: true })
          console.log('send', newIntent)
        }
      }, 30000)
    }
    return this
  }
  //浏览器是否最小化
  isMinStatus() {
    var isMin = false;
    if (window.outerWidth != undefined) {
      isMin = window.outerWidth <= 160 && window.outerHeight <= 27;
    }
    else {
      isMin = window.screenTop < -30000 && window.screenLeft < -30000;
    }
    return isMin;
  }

  receiveMessage(data) {
    const { type, sdp, id, label, candidate } = data.info

    switch (type) {
      case 'offer':
        const paylode = { type: 'offer', sdp }
        this.answererPeer(paylode)
        break
      case 'candidate':
        const paylodex = { id, label, candidate, sdpMid: id, sdpMLineIndex: label }
        if (paylodex) {
          this.answerer.addIceCandidate(new RTCIceCandidate(paylodex))
        }
        break
    }
  }

  answererPeer(offer) {
    let iceServers = [
      {
        urls: "turn:39.106.177.65:3479",
        username: "demo",
        credential: "growlib.com"
      },
      {
        urls: "stun:stun.schlund.de"
      }
    ]
    let config = {
      iceServers: iceServers
    }
    const answerer = this.answerer = new RTCPeerConnection(config)
    let that = this
    let inboundStream = null;
    // if(issafari){
    if (typeof answerer.ontrack != 'undefined') {
      answerer.ontrack = event => {
        console.log('gotRemoteStream', event.track, event.streams[0]);
        if (event.streams && event.streams[0]) {
          setTimeout(() => {
            this.video.srcObject = event.streams[0];
            const playPromise = this.video.play()
            if (playPromise !== null) {
              playPromise.catch(() => { this.video.play(); })
            }

          }, 150)

        } else {
          if (!inboundStream) {
            inboundStream = new MediaStream();
            setTimeout(() => {
              this.video.srcObject = inboundStream;
              const playPromise = this.video.play()
              if (playPromise !== null) {
                playPromise.catch(() => { this.video.play(); })
              }

            }, 150)

          }
          inboundStream.addTrack(event.track);
        }

        // this.video.srcObject = null;
        // this.video.srcObject = event.streams[0];
        // this.video.srcObject = event.stream


      }
    } else {
      answerer.onaddstream = event => {

        if (event.stream) {
          this.video.srcObject = event.stream
        } else {
          if (!inboundStream) {
            inboundStream = new MediaStream();
            setTimeout(() => {
              this.video.srcObject = inboundStream;
              const playPromise = this.video.play()
              if (playPromise !== null) {
                playPromise.catch(() => { this.video.play(); })
              }


            }, 150)

          }
          inboundStream.addTrack(event.track);
        }



        // this.video.play()

      }
    }


    answerer.onicecandidate = event => {
      if (!event || !event.candidate) return

      const { candidate, sdpMid, sdpMLineIndex } = event.candidate

      this.send({
        msg_id: 30,
        info: {
          type: 'candidate',
          candidate,
          id: sdpMid,
          label: sdpMLineIndex,
        }
      })
    }

    answerer.setRemoteDescription(new RTCSessionDescription(offer))
    //     try{
    //         console.log('error11111111111111')
    //     	  answerer.createAnswer(answer => {
    //     	    answerer.setLocalDescription(answer)
    //     	    that.send({
    //     	      msg_id: 30,
    //     	      info: {
    //     	        type: answer.type,
    //     	        sdp: answer.sdp,
    //     	      }
    //     	    })
    //     	}, () => {}, mediaConstraints)
    //       
    //     }catch(e){
    console.log('error')
    if (!sendAnswer) {
      answerer.createAnswer().then(function (answer) {
        that.send({
          msg_id: 30,
          info: {
            type: answer.type,
            sdp: answer.sdp,
            sendTime: new Date().getTime()
          }
        })
        sendAnswer = true
        console.log('发送answer')
        return answerer.setLocalDescription(answer)
      }).then(function () {
        // Send the answer to the remote peer through the signaling server.
      })
        .catch(function (e) {

        });
    }
    // }

  }
}

export default VrClient
